
import moment from 'moment';
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { getPayments, updateResend, updateUserRecharge } from '@/api/coinManaging';
import { PageQuery } from '@/mixins/page_query';
import { toast } from '@/utils/common';
import { done } from 'nprogress';

@Component({
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
  },
})
export default class RechargeRecord extends Mixins(PageQuery) {
  private start!: any;
  private end!: any;
  private dates: (string | Date)[] = [
    moment()
      .subtract('months', 3)
      .format('YYYY-MM-DD'),
    moment('23:59:59', 'HH:mm:ss').format(),
  ];
  private order_no = '';
  private nickname = '';
  private out_order_no = '';
  private uid = '';
  pwd = '';
  private pickerOptions = {
    shortcuts: [
      {
        text: '最近一周',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '最近一个月',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        },
      },
      {
        text: '最近三个月',
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        },
      },
    ],
  };
  private payStatuses = [
    {
      value: 0,
      label: '全部支付状态',
    },
    {
      value: 1,
      label: '支付成功',
    },
    {
      value: -1,
      label: '支付失败',
    },
  ];
  private completedStatuses = [
    {
      value: 0,
      label: '全部上账状态',
    },
    {
      value: 1,
      label: '待上账',
    },
    {
      value: 2,
      label: '成功',
    },
  ];
  private payStus = 0;
  private completedStas = 0;

  private tableData = [];
  private payTp = 0;
  // payTypes = ['未知', '微信', '兑换码', '支付宝', '福利任务', '推广码'];
  payTypes = [
    // { id: -2, name: '请选择' },
    { id: 0, name: '请选择' },
    { id: 1, name: '微信' },
    { id: 2, name: '兑换码' },
    { id: 3, name: '支付宝' },
    { id: 4, name: '福利任务' },
    { id: 6, name: '推广码' },
    { id: 7, name: 'IOS支付' },
    { id: 8, name: '谷歌内购' },
    { id: 9, name: 'paypal支付' },
    { id: 10, name: 'PingPong' },
    { id: -10, name: '拉新邀请' },
  ];
  getPayTypes(type: number) {
    let value = '';

    // switch (type) {
    //   case 0:
    //     value = '未知';
    //     break;
    //   case 1:
    //     value = '微信';
    //     break;
    //   case 2:
    //     value = '兑换码';
    //     break;
    //   case 3:
    //     value = '支付宝';
    //     break;
    //   case 4:
    //     value = '福利任务';
    //     break;
    //   case 6:
    //     value = '推广码';
    //     break;
    // }
    // console.log(type, value);
    const item = this.payTypes.find((item, i) => {
      return item.id == type;
    });
    if (item) {
      value = item.name;
    }
    return value;
  }
  dateHandler(e: any) {
    this.start = moment(e[0], 'YYYY-MM-DD');
    this.end = moment(e[1]).unix() + (24 * 60 * 60 - 1);
  }
  searchList() {
    this.page_query.page = 1;
    this.getList();
  }
  async issue(order_no: string) {
    this.$confirm('是否确认发放？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      center: true,
    })
      .then(async () => {
        const res: any = await updateResend({ order_no: order_no });
        if (res && res.code == 0) {
          toast('发放成功');
          this.getList();
        } else {
          toast(res.msg, 'warning');
        }
      })
      .catch(() => {
        toast('已取消', 'warning');
      });
  }
  async getList() {
    try {
      const query = {
        page: this.page_query.page,
        page_size: this.page_query.page_size,
        start: moment(this.start).unix(),
        end: this.end,
        nickname: this.nickname,
        uid: this.uid,
        order_no: this.order_no,
        out_order_no: this.out_order_no,
        pay_status: this.payStus,
        pay_type: this.payTp != 0 ? this.payTp : '',
        complete_status: this.completedStas,
      };
      const res = await getPayments(query);
      if (res && res.data.list) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    } catch (error) {
      // this.$log.debug(error);
    }
  }
  async refund(order_no: string) {
    const h = this.$createElement;
    let that = this;

    this.$msgbox({
      title: '提示',
      message: h('p', [
        h('div', '请输入系统口令 '),
        h('input', {
          attrs: {
            class: 'refund-input',
            value: that.pwd,
            placeholder: '输入（数字+字母）',
            id: 'hinput',
          },
          on: {
            input: this.handleClick,
          },
        }),
      ]),
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      center: true,
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          var str = this.pwd;
          var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
          if (!reg.test(str) || str.trim() == '') {
            toast('口令必须包含数字+字母', 'error');
            return;
          } else {
            done();
          }
        } else if (action === 'cancel') {
          this.clear();
          done();
        }
      },
    }).then(action => {
      this.comfirmRefound(order_no, h);
    });
  }
  handleClick() {
    this.pwd = (document.getElementById('hinput') as HTMLInputElement).value;
  }
  async comfirmRefound(order_no: string, h: any) {
    this.$msgbox({
      title: '提示',
      center: true,
      message: h(
        'div',
        {
          class: 'comfirm-desc',
        },
        [
          h('div', { class: 'comfirm-center' }, '确定清空该订单吗？ '),
          h('div', { class: 'comfirm-left' }, '如是云币，会从用户账户扣除对应面额 '),
          h('div', { class: 'comfirm-left' }, '云币，账户云币不足，则扣为0 '),
          h('div', { class: 'comfirm-left' }, '如是周期卡，则对应周期卡失效 '),
          h('div', { class: 'comfirm-left' }, '如果是云朵，会从用户账户扣除对应面额的云朵，账户云朵不足，则扣为0 '),
        ]
      ),
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          try {
            const res: any = await updateUserRecharge({ order_no: order_no, pwd: this.pwd });
            if (res && res.code == 0) {
              toast('操作成功');
              this.getList();
            }
          } finally {
            instance.confirmButtonLoading = false;
            done();
          }
        } else if (action === 'cancel') {
          done();
        }
      },
    }).finally(() => {
      done();
      this.clear();
    });
  }
  clear() {
    const doc = document.getElementById('hinput') as HTMLInputElement;
    if (doc) {
      doc.value = '';
    }

    this.pwd = '';
  }
  mounted() {
    this.start = this.dates[0];
    this.end = moment(this.dates[1]).unix();
    this.pageFn = this.getList;
    this.getList();
  }
}
